"use client";

import { useEffect } from "react";
import { useLocale } from "next-intl";

export default function HtmlLangSetter() {
  const locale = useLocale();

  useEffect(() => {
    if (document.documentElement.lang !== locale) {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  return null;
}
